export const APP_MAX_WIDTH_NARROW = 'calc(600px + 1rem * 2)'
export const APP_MAX_WIDTH_WIDE = 'calc(800px + 1rem * 2)'

/** Int-style wide shell: help only (login form stays on the redesign width). */
export function isWideLayoutPath(pathname: string): boolean {
  return pathname === '/help' || pathname.startsWith('/help/')
}
